<div class="custom-select" :class="customSelectActive">
    <button
            class="select-button"
            role="combobox"
            aria-label="select button"
            aria-haspopup="listbox"
            :aria-expanded="ariaExpandedBtn"
            aria-controls="select-dropdown"
            @click="showOption"
    >
        <span class="selected-value" ref="selected-value">{{placeholder_val}}</span>
        <span class="arrow"></span>
    </button>
    <ul class="select-dropdown" role="listbox" id="select-dropdown" ref="modalRef">
        <li role="option" ref="select-dropdown" v-for="option in options_val" :key="option.key" @click="chooseOption(option.value)">
            <span :data-val="option.value">{{option.name}}</span>
        </li>
    </ul>
</div>